import { forwardRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogContentText,
  Slide,
} from "@material-ui/core";
import { useMetamask } from "use-metamask";
import "./ConnectWalletPopupStyle.css";
import { metaMaskLogo, walletConnectLogo } from "../assets";

void walletConnectLogo;

const Transition = forwardRef(function Transition(props, ref) {
  // @ts-ignore
  return <Slide direction="up" ref={ref} {...props} />;
});

const ConnectWalletPopup = (props) => {
  const { connectPopupOpen, setConnectPopupOpen, onClick } = props;
  let { metaState } = useMetamask();
  return (
    <Dialog
      open={connectPopupOpen}
      // @ts-ignore
      TransitionComponent={Transition}
      keepMounted
      onClose={() => setConnectPopupOpen(false)}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      fullWidth
      PaperProps={{ style: { borderRadius: "12px" } }}
      maxWidth="xs"
      style={{ padding: "0px" }}
      className="connect-wallet-popup"
    >
      <DialogContent>
        <DialogContentText
          id="alert-dialog-slide-description"
          style={{ color: "black" }}
          component="div"
        >
          <div
            className="connect-wallet-items metamask"
            onClick={() => {
              if (metaState.isAvailable) onClick("metamask");
              else window.open("https://metamask.io/download.html", "_blank");
            }}
          >
            <img src={metaMaskLogo} alt="metamask" />
            <div className="title">MetaMask</div>
            <small>{!metaState.isAvailable && "[INSTALL]"}</small>
            <div className="description">Connect to your MetaMask Wallet</div>
          </div>
          <div
            className="connect-wallet-items wallet-connect"
            onClick={() => onClick("connectwallet")}
          >
            <img src={walletConnectLogo} alt="walletConnectLogo" />
            <div className="title">WalletConnect</div>
            <div className="description">
              Scan with WalletConnect to connect
            </div>
          </div>
        </DialogContentText>
      </DialogContent>
    </Dialog>
  );
};

export default ConnectWalletPopup;
